import { Field, useFormikContext } from "formik";
import { useState } from "react";

import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import { useDispatch, useSelector } from "react-redux";
import { getChangedDocumentsModuleData } from "config/changesDocumentData";

const ShareTransferChangeDocuments = ({
  field,
  form,
  resolvedFields = [],
  ...props
}) => {
  const documents = getChangedDocumentsModuleData(
    "shareTransferChangeDocuments"
  );

  return (
    <div className="container bg-white mt-6 px-4 py-4 shadow-sm rounded-md">
      <Field
        // MODIFIED: Target statutoryDeclaration.statutoryDeclaration for files
        name={`${field.name}`}
        component={FileUploadForm}
        documentData={documents}
        disabled={false}
      />
    </div>
  );
};

export default ShareTransferChangeDocuments;
